module.exports = __webpack_public_path__ + "img/1.245a1177.jpg";